module.exports = __webpack_public_path__ + "static/media/beautiful-stories.abd940b5.jpg";